import React, { Component } from 'react';
import PropTypes from 'prop-types';

//Styles
import { fontWeightBold } from '../../../helpers/getEmailStyles';

class EmailSignature extends Component {
    static propTypes = {
        siteName: PropTypes.string.isRequired,
    }
    render() {
        const { siteName } = this.props;
        return (
            <div>
                Merci, <br />
                L'équipe <span style={fontWeightBold}>{siteName}</span>
            </div>
        )
    }
}

export default EmailSignature;